import identity from "lodash/fp/identity";
class BulkBonusDetailsPageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    return identity(data);
  }
}

export default BulkBonusDetailsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/bulkBonusDetails/bulkBonusDetails.transforms.js